<template>
  <div
    class="dark:bg-ontick-steel-500 bg-ontick-steel-300 relative flex h-5 w-36 items-center justify-between overflow-hidden rounded-sm px-2 text-xs"
    :class="
      active
        ? `text-ontick-carbon-900 ${
            ['ON_WAIT', 'ON_WAIT_ENTRY', 'ON_WAIT_EXIT'].includes(status)
              ? 'dark:text-gray-300'
              : 'dark:text-white'
          }`
        : 'text-gray-400 dark:text-gray-500'
    "
  >
    <!-- v-tippy="{ arrow: true, theme: 'green' }" :content="tooltipStatus" -->
    <!-- Barra de progresso -->
    <div
      class="absolute left-0 h-full transition-all duration-500 ease-in-out"
      :class="bgProgress()"
      :style="`width: ${progress}%`"
    ></div>
    <span
      class="z-10"
      :class="styleVolume"
      v-tippy="{ arrow: true, theme: 'green' }"
      content="Volume atual"
    >
      {{ displayVolume }}
    </span>
    <span
      class="z-10 text-right"
      :class="styleVolume"
      v-tippy="{ arrow: true, theme: 'green' }"
      content="Preço médio"
    >
      {{ displayPrice }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    symbol: {
      type: String,
    },
    price: {
      type: Number,
    },
    volumeFilled: {
      type: Number,
    },
    totalVolume: {
      type: Number,
    },
    currentVolume: {
      type: Number,
    },
    status: {
      type: String,
    },
    orderStatus: {
      type: String,
    },
    active: {
      type: Boolean,
    },
  },

  computed: {
    progress() {
      // return (this.currentVolume / this.totalVolume) * 100;
      // if (this.status === "ON_WAIT_EXIT") return 0;
      return this.currentVolume;
    },
    styleVolume() {
      if (this.status === "NEW") return "font-normal";
      if (
        this.status === "ON_WAIT_ENTRY" &&
        this.orderStatus != "REJECTED" &&
        this.orderStatus != "STOPPED"
      )
        return "font-normal";
      if (this.status === "ON_WAIT_EXIT") return "font-normal";
      return "font-semibold";
    },
    displayVolume() {
      // {{ status === "FILLED" ? "Finalizada" : volumeFilled }}
      // if (this.status === "NEW") return "Nova";
      if (this.status === "NEW") return "-";
      if (
        this.status === "ON_WAIT_ENTRY" &&
        this.orderStatus != "REJECTED" &&
        this.orderStatus != "STOPPED"
      )
        return "Aguardando entrada";
      // if (this.status === "ON_ENTRY") return "Executando entrada";
      if (this.status === "ON_WAIT_EXIT") return "Aguardando saída";
      // if (this.status === "ON_EXIT") return "Executando saída";
      // if (this.status === "ON_TP") return "Executando TP";
      // if (this.status === "ON_SL") return "Executando SL";
      // if (this.status === "ON_TIME_EXIT") return "Saída temporal";
      // if (this.status === "FILLED") return "Executada";

      return Number.parseFloat(this.volumeFilled).toLocaleString();
    },
    tooltipStatus() {
      switch (this.status) {
        case "NEW":
          return "Aguardando";
        case "ACTIVE": //bolinha cinza
          return "Ativa";
        case "ON_WAIT_ENTRY": //bolinha azul
          return "Aguardando entrada";
        case "ON_ENTRY": //seta dupla para direita
          return "Executando entrada";
        case "ON_WAIT_EXIT": //bolinha azul
          return "Aguardando saída";
        case "ON_EXIT": //seta dupla para esquerda
          return "Executando saída";
        case "ON_TP": //seta dupla para esquerda
          return "Executando TP";
        case "ON_SL": //seta dupla para esquerda
          return "Executando SL";
        case "ON_TIME_EXIT": //seta dupla para esquerda
          return "Saída por tempo";
        case "FILLED": //ícone de check
          return "Finalizada";
        case "REJECTED": //ícone de ordem rejeitada
          return "Ordem rejeitada";
        case "PARTIALLY_FILLED":
          return "Parcialmente executado";
        default:
          return this.status;
      }
    },
    displayPrice() {
      if (this.status === "NEW") return "";
      if (
        this.status === "ON_WAIT_ENTRY" &&
        this.orderStatus != "REJECTED" &&
        this.orderStatus != "STOPPED"
      )
        return "";
      if (this.status === "ON_WAIT_EXIT") return "";

      return Number.parseFloat(this.price).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      });
    },
  },
  methods: {
    bgProgress() {
      if (this.status === "FILLED") return "bg-ontick-green-800";
      if (this.status === "REJECTED") return "bg-ontick-red-600";
      if (this.status === "ON_EXIT") return "bg-ontick-orange-600";

      if (
        ["ON_WAIT_ENTRY", "PARTIALLY_FILLED", "REJECTED"].includes(
          this.status
        ) &&
        ["REJECTED"].includes(this.orderStatus)
      )
        return "bg-ontick-red-600";

      if (
        ["ON_WAIT_ENTRY", "PARTIALLY_FILLED", "FILLED"].includes(this.status) &&
        ["STOPPED"].includes(this.orderStatus)
      )
        return "bg-ontick-steel-400";

      return "bg-ontick-blue-600";
    },
  },
};
</script>
